// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__pbH8O","textarea-view":"textarea_textarea-view__oQbZf"};